import { render } from "./FeesTable.vue?vue&type=template&id=4addb8b5"
import script from "./FeesTable.vue?vue&type=script&lang=js"
export * from "./FeesTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__